import React from "react";
import Marty from "marty";
//import { Link } from "react-router";

let Verify = React.createClass({
    componentWillMount() {
        if (Marty.isBrowser) {
            document.title = "eero - Thank you for verifying";
        }
    },
    render() {
        return (
            <section className="eo-view verify">
                <div className="verify-content">
                    <h1 className="heading">Thanks for verifying your email.</h1>
                    { /* <div className="help-btn-container grid-5 grid-s-10">
                        <Link className="help-btn eo-btn-outline gray hover-blue" to="support">Set up your system</Link>
                    </div>
                    <div className="about-btn-container grid-5 grid-s-10">
                        <Link className="about-btn eo-btn-outline gray hover-blue" to="features">Learn more</Link>
                    </div>*/ }
                </div>
            </section>
        );
    }
});

export default Verify;



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/verify/Handler.js
 **/